// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3Yii9","list":"styles_list__3PID9"};